import type {
  GestureEventPayload,
  PanGestureHandlerEventPayload,
} from 'react-native-gesture-handler';

export type UseCardGesturesProps = Readonly<{
  snapPoints: SwipeSnapPoints;
  minSwipeDistance: number;
  maxSwipeDistance: number;
  onSwipeEnd?: () => void;
  callback?: (() => void) | (() => Promise<void>);
}>;

export type GestureHandlerProps = Readonly<
  GestureEventPayload & PanGestureHandlerEventPayload
>;

export enum SwipeStatus {
  Idle = 'idle',
  Expanding = 'expanding',
  Expanded = 'expanded',
  Busy = 'busy',
}

export type SwipeSnapPointThresholds = Readonly<{
  min: number;
  max: number;
}>;

export type SwipeSnapPoint = Readonly<{
  width: number;
  thresholds: SwipeSnapPointThresholds;
  shouldTriggerCallback?: boolean;
}>;

export type SwipeSnapPoints = readonly SwipeSnapPoint[];

export type SetNewSwipeDistanceProps = Readonly<{
  distance: number;
  smooth?: boolean;
  newStatus?: SwipeStatus;
}>;

export type AnimatedGestureHandlerContext = {
  offsetX: number;
};
